export default __webpack_public_path__ + "static/gabrielwong2-4c8b22aae4c13267a4b5336646b61c15.jpg";